<template>
	<v-tooltip max-width="500px">
		<template v-slot:activator="{ props }">
			<Information16
				v-bind="props"
				color="var(--sgnl-default-secondary-icon)"
			/>
		</template>
		{{ disclosureText }}
	</v-tooltip>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Information16 from "@carbon/icons-vue/es/information/16";

export default defineComponent({
	name: "DisclosureIcon",
	components: { Information16 },
	props: { disclosureText: { type: String, required: true } },
});
</script>
